import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { DEFAULT_LOCALE } from '@rover/constants/src/i18n/locale';

import generateExternalFormatMap from './generateExternalFormatMap';
import generateFormatMap from './generateFormatMap';
import getLocalizedFormatContextless from './getLocalizedFormatContextless';

export const getExternalFormatMap = (locale?: Locale): Record<string, string> =>
  generateExternalFormatMap(getLocalizedFormatContextless, locale);

export const getDateTimeFormatMapForLocale = (locale?: Locale): Record<string, string> =>
  generateFormatMap(getLocalizedFormatContextless, locale);

export const defaultDateTimeFormatMap = getDateTimeFormatMapForLocale(DEFAULT_LOCALE);

// Default export for backward compatibility
export { getDateTimeFormatMapForLocale as default };

// Additional exports
export { getLocalizedFormatContextless as getLocalizedFormat };
